<template>
	<Modal width="850px">
		<template #modal-title>
			Request New Consents
			<v-spacer />
			<IconButton @click="$emit('close')">
				mdi-close
			</IconButton>
		</template>
		<template #modal-content>
			<div class="cassie-vertical-md">
				<v-row>
					You have made an update to a service that is in use on a consent banner and should consider triggering a force reconsent. Would you like to request new consents for the affected banners now?
				</v-row>
				<v-row>
					<strong>
						Associated Consent Banners:
					</strong>
				</v-row>
				<v-row>
					<ul
						:style="associatedConsentBanners.length > 10 ? 'max-height: 250px; overflow-y: auto; width: 100%;' : 'width: 100%;'"
					>
						<li
							v-for="banner in associatedConsentBanners"
							:key="banner.bannerId"
						>
							{{ banner.bannerName }} ({{ banner.brandName }})
						</li>
					</ul>
				</v-row>
			</div>
		</template>
		<template #modal-footer>
			<SecondaryActionButton @click="$emit('no-new-consents')">
				No
			</SecondaryActionButton>
			<PrimaryActionButton
				@click="$emit('request-new-consents')"
			>
				Yes
			</PrimaryActionButton>
		</template>
	</Modal>
</template>

<script>
import Modal from '../../../../../../../shared/components/modal.vue'
import SecondaryActionButton from '../../../../../../../shared/components/secondary-action-button.vue'
import PrimaryActionButton from '../../../../../../../shared/components/primary-action-button.vue'
import IconButton from '../../../../../../../shared/components/icon-button.vue'

export default {
	components: {
		Modal,
		SecondaryActionButton,
		PrimaryActionButton,
		IconButton
	},
	props: {
		associatedConsentBanners: {
			type: Array,
			required: true
		}
	}
}
</script>
